/** Map shop.active / API English copy onto dashboard banner keys. */
export function shopErrorBannerKey(
    active: string | number | null | undefined,
    errorMessage?: string
): "dashboard.accountSuspendedBanner" | "dashboard.shopifyAccountSuspendedBanner" | null {
    const v = String(active ?? "").toLowerCase();
    if (v === "suspended" || v === "2") {
        return "dashboard.accountSuspendedBanner";
    }
    if (v === "3" || v === "blocked") {
        return "dashboard.shopifyAccountSuspendedBanner";
    }
    const msg = errorMessage ?? "";
    if (msg.includes("EmailWish account is currently suspended")) {
        return "dashboard.accountSuspendedBanner";
    }
    if (msg.includes("Shopify account is suspended")) {
        return "dashboard.shopifyAccountSuspendedBanner";
    }
    return null;
}
